import { render, staticRenderFns } from "./notesLarge.vue?vue&type=template&id=e2a7054e&scoped=true&"
import script from "./notesLarge.vue?vue&type=script&lang=js&"
export * from "./notesLarge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a7054e",
  null
  
)

export default component.exports